import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { RecipientRequestType } from '@/types/vendorVaultTypes';

export type RecipientRequestStageActionType = 'created-in-bank' | 'close';

export const recipientRequestStageApi = (
  id: string,
  stage: RecipientRequestStageActionType
): Promise<ApiResponseType<RecipientRequestType>> =>
  authApiService.POST(`/vendor-vault/requests/${id}/stage/${stage}/`, {});
